const issueStatusOptions = [
  { value: "NEEDS_ATTENTION", label: "Needs Attention" },
  { value: "PENDING", label: "Pending" },
  { value: "RESOLVED", label: "Resolved" },
  { value: "ARCHIVED", label: "Archived" }
];

export default issueStatusOptions;
